import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

interface NavIconLinkProps {
  to: string;
  title: string;
  icon: ReactNode;
  end?: boolean;
  className?: string;
}

export function NavIconLink({ to, title, icon, end, className }: NavIconLinkProps) {
  return (
    <NavLink
      to={to}
      end={end}
      title={title}
      aria-label={title}
      className={({ isActive }) =>
        cn(
          'inline-flex items-center justify-center rounded-md p-2 transition-colors hover:text-foreground',
          isActive ? 'text-foreground' : 'text-muted-foreground',
          className
        )
      }
    >
      {icon}
    </NavLink>
  );
}
